import env from '../config/env';

// À déplacer dans vos variables d'environnement (valeurs reprises d'AdvancedConfigPage)
const CLOUD = 'dtrkcpsky';
const PRESET = 'r6s4af83';

// Réduit les photos de téléphone (5-10 Mo) à ~300 Ko : l'envoi et l'analyse sont bien plus rapides
export async function downscaleImage(file, maxSide = 1600, quality = 0.85) {
  try {
    const bitmap = await createImageBitmap(file);
    const ratio = Math.min(1, maxSide / Math.max(bitmap.width, bitmap.height));
    const canvas = document.createElement('canvas');
    canvas.width = Math.round(bitmap.width * ratio);
    canvas.height = Math.round(bitmap.height * ratio);
    canvas.getContext('2d').drawImage(bitmap, 0, 0, canvas.width, canvas.height);
    bitmap.close?.();
    const blob = await new Promise((resolve) => canvas.toBlob(resolve, 'image/jpeg', quality));
    return blob ? new File([blob], 'photo.jpg', { type: 'image/jpeg' }) : file;
  } catch {
    return file;
  }
}

export async function uploadToCloudinary(file) {
  const body = new FormData();
  body.append('file', file);
  body.append('upload_preset', PRESET);
  const res = await fetch(`https://api.cloudinary.com/v1_1/${CLOUD}/image/upload`, {
    method: 'POST',
    body,
  });
  if (!res.ok) throw new Error('Upload impossible');
  return (await res.json()).secure_url;
}

// "Position actuelle" n'est pas un libellé publiable : on le remplace par la ville
export async function reverseCity(lat, lng) {
  try {
    const url =
      `https://api.mapbox.com/geocoding/v5/mapbox.places/${lng},${lat}.json` +
      `?types=place&language=fr&limit=1&access_token=${env.mapboxToken}`;
    const data = await (await fetch(url)).json();
    return data?.features?.[0]?.place_name || null;
  } catch {
    return null;
  }
}
